<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">事業所一覧</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <!-- Column -->
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper dt-bootstrap no-footer">
                <div class="row pb-2">
                  <div class="col-sm-12">
                    <div class="data-actions" v-if="false">
                      <router-link to="/office/new" class="btn btn-rounded btn-outline-info">
                        <i class="fa fa-plus"></i>事業所を新規登録する
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="data">
                  <div class="col-sm-12">
                    <div class="table-responsive">
                      <table id="myTable" class="table table-sm table-bordered">
                        <thead>
                        <tr>
                          <th>事業所名</th>
                          <th>略称</th>
                          <th>フリガナ</th>
                          <th>登録日時</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="office in data" :key="office.id">
                          <td>
                            {{office.display_name}}
                          </td>
                          <td>{{office.short_name}}</td>
                          <td>{{office.display_name_kana}}</td>
                          <td>{{office.created_at}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useExecutor } from '@/libs/Executor'

// Store setup
const store = useStore()

const { exec } = useExecutor()

// Reactive state
const data = ref(null)
const isProcessing = ref(false)

// Methods
const getOffices = () => {
  return store.dispatch('office/getOffices')
}

const load = async () => {
  exec(async () => {
    isProcessing.value = true
    const res = await getOffices()
    data.value = res
    isProcessing.value = false
  }).catch((error) => {
    console.error('Error loading offices:', error)
  })
}

// Lifecycle hooks
onMounted(() => {
  load()
})
</script>

<style lang="scss" scoped>
.data-actions {
  text-align: right;
}
</style>
